import React from 'react';
import NewsPage from '../../../Domains/News/Pages/NewsPage';
import {Container} from 'react-bootstrap';
import {PageTitle} from '../../../_metronic/layout/core';
import TabComponent from '../../common/components/TabComponent';
import AdminDocumentManager from './documents/AdminDocumentManager';

const AdminDashboard = () => {
  return (
    <Container fluid>
      <PageTitle breadcrumbs={[]}>Admin</PageTitle>
      <TabComponent
        tabData={[
          {
            title: 'Documents',
            key: 'commonFiles',
            content: <AdminDocumentManager />,
          },
          {
            title: 'News',
            key: 'bills',
            content: <NewsPage />,
          },
        ]}
      />
    </Container>
  );
};

export default AdminDashboard;
